import { type WrappedInsightType } from "@clipboard-health/contract-worker-app-bff";

import { KNOWN_INSIGHT_TYPES, type KnownInsightType } from "./types";

/**
 * This function is needed to filter out insights that frontend doesn't know about.
 * It prevents from backend changes in the structure to render empty insight
 */
export function isKnownInsight(insightType: WrappedInsightType): insightType is KnownInsightType {
  return KNOWN_INSIGHT_TYPES.includes(insightType);
}
